import { render, staticRenderFns } from "./toto.vue?vue&type=template&id=1123e0e6"
import script from "./toto.vue?vue&type=script&lang=js"
export * from "./toto.vue?vue&type=script&lang=js"
import style0 from "./toto.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/toto/toto.vue
// module id = /ITa
// module chunks = 0